import { TableCssClassName as ClassName } from '../types';
export var updateShadowListForStickyStyles = function updateShadowListForStickyStyles(heightStyle, shadows) {
  Array.from(shadows).forEach(function (shadow) {
    if (shadow.classList.contains(ClassName.TABLE_STICKY_SHADOW)) {
      if (shadow instanceof HTMLElement && shadow.style.height !== heightStyle) {
        shadow.style.height = heightStyle;
      }
    }
  });
};